import { Link } from 'react-router-dom';
import styles from './SellerAppliedPage.module.css';

export default function SellerAppliedPage() {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.icon}>📋</div>
        <h1 className={styles.title}>Application submitted!</h1>
        <p className={styles.sub}>
          Your seller application is under review. Our team will get back to you within <strong>24 hours</strong>.
        </p>
        <div className={styles.steps}>
          {[
            { icon: '✅', text: 'Application received' },
            { icon: '⏳', text: 'Admin review (up to 24hrs)' },
            { icon: '📱', text: 'You\'ll be notified via email' },
            { icon: '🚀', text: 'Start selling once approved' },
          ].map(s => (
            <div key={s.text} className={styles.step}>
              <span>{s.icon}</span>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
        <Link to="/home" className={styles.homeBtn}>Back to home</Link>
        <Link to="/profile" className={styles.profileLink}>View my profile</Link>
      </div>
    </div>
  );
}
